import { dpr } from 'Utils/dpr';
import tailwindBreakpoints from 'Utils/tailwindBreakpoints';

import { ISrcSetSize } from 'Components/ProductCard/ProductCardImage';

interface ISourceSetPictureSourceProps {
    srcSetSizes: ISrcSetSize;
    src: string;
}

const SourceSetPictureSource = ({
    srcSetSizes,
    src,
}: ISourceSetPictureSourceProps) =>
    Object.entries(srcSetSizes).map(([key, value]) => {
        if (tailwindBreakpoints[key] === undefined) return false;
        const sizeValue = value as ISrcSetSize['default'];
        return (
            <source
                key={key}
                width={sizeValue.width}
                height={sizeValue.height}
                media={`(min-width: ${tailwindBreakpoints[key]})`}
                srcSet={
                    !src
                        ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAA1JREFUGFdjmLxn8X8ABsoC8muPGUAAAAAASUVORK5CYII='
                        : dpr(
                              `${src}?format=webp&fit=crop&height=${sizeValue.height}&width=${sizeValue.width}`
                          )
                }
            />
        );
    });

export default SourceSetPictureSource;
